import React, { Component } from 'react'
import {connect} from 'react-redux';
import cs from 'classnames';
import mapDispatch from '~/misc/mapDispatch';
import Status from '~/components/pages/MyAccount/BidVerfiy/component/status'
import Upload from '~/components/pages/MyAccount/BidVerfiy/component/upload';
import { uploadW9form, uploadInfoForLoadsmart} from '~/modules/user/actions';
import css from './index.css'
const statusMap = {
  "NoDotMc": "NotVerified",
  "pending": "Pending",
  "Onboarding": "Onboarding",
}
class LoadsmartUpload extends Component {
  constructor(props) {
    super();
    this.state = { 
      types: [],
      page: ''
    }
  }
  componentWillMount() {
    const { query } = this.props.location;
    const types = query.uploadType ? query.uploadType.split(",") : [];
    const {status, id, token} = query;
    this.setState({
      types, status, id, token, 
      page: statusMap[status]
    })
  } 
  uploadImg = (file) => {
    const { id, token } = this.state;
    const { uploadImg } = this.props;
    return uploadImg({
      id,
      token,
      file,
    })
  }
  uploadInfo = (pics) => {
    const { id, token } = this.state;
    const { uploadInfo } = this.props;
    const { companyName, legalName, phone, mc, dot, authority } = this.props.user
    const files = {
      info: {
        companyName, legalName, phone, mc, dot, authority 
      },
      ...pics
    }
    return uploadInfo({
      id,
      token,
      files,
    }).then((res)=> {
      const { code } =  res;
      if(code !== 200) throw new Error();
      this.setState({
        page: statusMap["Onboarding"]
      })
      history.replaceState({}, "", "/uploadLoadsmart?status=Onboarding");
    }).catch(()=> {
      window.alert("Upload failed, please try again.")
    })
  } 
  render() {
    const { page } = this.state;
    if (page === "NotVerified") {
      return (
        <div className={css.warp}>
          <Status
            type="notverify"
          />
        </div>
      )
    }
    if (page === "Pending") {
      return (
        <div className={css.warp}>
          <Status
            type="pending"
          />
        </div>
        
      )
    }
    if(page === "Onboarding") {
      return  (
        <div className={css.warp}>
          <Status
            type="onboarding"
          />
        </div>
      )
    }
    if (page === "Success") {
      return (
        <div className={css.warp}>
          <Status
            type="success"
          />
        </div>
      )
    }
    return (
      <div className={css.warp}>
        <Upload
          acceptType = { this.state.types }
          uploadImg = {this.uploadImg}
          uploadInfo = {this.uploadInfo}
        ></Upload>
      </div>
    )
  }
}

export default connect(({user}) => {
  return {user}
}
, mapDispatch({
  uploadImg: (props, {id, token, file}) => uploadW9form(id, token, file),
  uploadInfo: (props, {id, token, files}) => uploadInfoForLoadsmart (id, token, files),
}))(LoadsmartUpload);


// WEBPACK FOOTER //
// ./src/components/pages/LoadsmartUpload/index.js